<template>
		<MainLayout>
			<div class="container">
				<div class="box">
					<b-button v-if="$hasPermission('place.add')" class="float-right" @click="newModel" >Nuevo Destino</b-button>
					<h2>Destino</h2>
					<hr>
					<b-form @submit="(evt) => { evt.preventDefault(); this.$root.$emit('bv::refresh::table', 'places-index-list') } ">
						<div class="row">
							<b-form-group class="col-2" label="Nombre">
								<b-form-input v-model="filters.search" type="text" />
							</b-form-group>
							<b-form-group class="col-2" label="Ciudad">
								<b-form-input v-model="filters.ciudad" type="text" />
							</b-form-group>
							<b-form-group class="col-2" label="Datos extendidos">
								<b-form-select v-model="filters.extend" :options="optExtended"></b-form-select>
							</b-form-group>
							<b-form-group class="col-2" label="Origen">
								<b-form-select v-model="filters.source" :options="optSource"></b-form-select>
							</b-form-group>
							<b-form-group class="col-2" label=".">
								<b-button type="submit" variant="primary">Buscar</b-button>
							</b-form-group>
						</div>
					</b-form>
					<AjaxTable
						permission-show="place.show"
						id="places-index-list"
						:filters="filters"
						:columns="modelColumns"
						resource="places"
					>
						<template #cell(actions)="row">
							<div class="text-center">
								<b-button @click="(event) => editModel(row.item.id)" type="button" size="sm" class="mr-1" variant="info">
									<md-icon icon="edit" />
								</b-button>
								<b-button v-if="$hasPermission('place.delete')" @click="(event) => modelDelete(row.item,row.index,event)" type="button" size="sm" class="mr-1" variant="danger">
									<md-icon icon="delete" />
								</b-button>
							</div>
						</template>
						<template #cell(locationUrl)="row">
							<div v-if="row.item.locationUrl" class="text-center">
								<a :href="row.item.locationUrl" target="_blank" class="btn btn-sm" variant="info">
									<md-icon icon="place" />
								</a>
							</div>
						</template>
						<template #cell(referenceToPlace)="row">

							<span v-if="row.item.referenceToPlace.id > 0">{{row.item.referenceToPlace.id}} {{row.item.referenceToPlace.name}}</span>
						</template>
						<template #cell(coords)="row">
							{{row.item.longitude}},{{row.item.latitude}}
						</template>
					</AjaxTable>
				</div>
				<hr>
			</div>
			<Single :unableEdit.sync="unableEdit" mode="place" ref="single" :success-callback="successCallback" />
		</MainLayout>
</template>

<script>
import MainLayout from '../layout/MainLayout.vue'
import AjaxTable from '../../helpers/AjaxTable.vue'
import Single from './Single.vue'
import api from '../../../api.js'

export default {
		components: { MainLayout, Single, AjaxTable },
		data(){
				return {
					unableEdit: false,
					modalInfo : {
						modelId:-1,
						title:"Destino",
					},
					filters : {
						search:'',
						ciudad: '',
						extend: '',
						source: '',
					},
					optExtended: [
						{ value: '', text: 'Seleccione una opción' },
						{ value: 'notExtended', text: 'No Extendidos' },
						{ value: 'notMatchFound', text: 'No encontrados' },
						{ value: 'gplace', text: 'G Places' },
						{ value: 'manual', text: 'Manual' },
					],
					optSource: [
						{ value: '', text: 'Seleccione una opción' },
						{ value: 'sc', text: 'Shuttle Central' },
						{ value: 'bookingCom', text: 'Booking.com API' },
						{ value: 'jayride', text: 'Jayride' },
						// { value: 'manual', text: 'Manual' },
					],
					modelColumns : [
						{key:'id',label:'ID'},
						{key:'name',label:'Nombre'},
						{key:'address',label:'Dirección'},
						{key:'destinationName',label:'Ciudad'},
						{key:'countryName',label:'País'},
						{key:'referenceToPlace',label:'Referencia a'},
						{key:'locationUrl',label:'Ubicación'},
						{key:'coords',label:'Coordenadas'},
						{key:'source',label:'Origen'},
						{key:'actions',label:'Acciones'},
					],
				}
		},
		methods:{
			successCallback(){
				this.$root.$emit('bv::refresh::table', 'places-index-list')
			},
			editModel(id){
				this.unableEdit = !this.$hasPermission('place.edit')
				this.$refs['single'].loadModel(id);
			},
			newModel(){
				this.unableEdit = false
				this.$refs['single'].loadModel(-1)
			},
			modelDelete(item) {
				this.$root.showWarning({
					okAction: (event, setLoading, close) => {
						setLoading(true)
						api(this).delete(`/places/${item.id}`).then((response) => {

							if (response.data.error) {
								this.$root.showAlert(response.data.message, {variant: 'warning'})
								close()
								return false
							}

							this.$root.showAlert('Registro Eliminado!', {variant: 'warning'})
							this.$root.$emit('bv::refresh::table', 'places-index-list')
							this.$root.auxVars.loadResourcesOpts({vm: this, resourceNames: ['destinationsOpts'],forceRefresh: true})
							close()
						}).catch(err => {
							this.$root.handleRequestError(err)
							close()
						});
					}
				})
			}
		},
		mounted(){
		}
}
</script>

<style>

</style>
